import { useEffect } from "react";

import { useModals, useRoleGuardHook } from "hooks";
import {
  useAuthActions,
  useDealActions,
  useReportsActions,
  useSelectError409,
  useTaskManageActions,
  useUserActions,
  useUserRoleSelector,
  useViewActions
} from "store";
import { IRole } from "store/types";
import { isRoleAnalyst } from "utils/user";

import { RoleName } from "../../constants";

export function useProtectedRoutesHooks() {
  const error409 = useSelectError409();
  const role: IRole | null = useUserRoleSelector();
  const { removeTokenAction } = useAuthActions();
  const { setLogoutToAnotherDeviceAction } = useViewActions();

  const { infoModal } = useModals();

  useEffect(() => {
    if (error409) {
      infoModal({
        msg: error409,
        action: () => {
          setLogoutToAnotherDeviceAction("");
          removeTokenAction();
        }
      });
    }
  }, [error409]);

  const { getDealsAction } = useTaskManageActions();
  const { getQuickViewMetadata } = useReportsActions();
  const {
    getDealStatusesAction,
    getAssetClassesAction,
    getMeasureParametersAction,
    getInvestorsAction,
    getMeasuresAction,
    getOpportunitiesAction,
    getDealsFiltersAction,
    getDocumentTypesAction
  } = useDealActions();
  const { getRolesAction, getAudienceAction, getBookmarksAction, getManagersAction } = useUserActions();

  const getOpportunitiesWithRole = useRoleGuardHook(getOpportunitiesAction, [RoleName.Admin, RoleName.Analyst]);
  const getQuickViewMetadataWithRole = useRoleGuardHook(getQuickViewMetadata, [
    RoleName.Admin,
    RoleName.Analyst,
    RoleName.TeamViewer
  ]);

  useEffect(() => {
    getDealStatusesAction();
    getAudienceAction();
    getRolesAction();
    getAssetClassesAction();
    getBookmarksAction();
    getMeasureParametersAction();
    isRoleAnalyst({ role, preventTV: true }) && getInvestorsAction();
    getDealsAction();
    isRoleAnalyst({ role, preventTV: true }) && getMeasuresAction();
    getManagersAction();
    getOpportunitiesWithRole?.();
    getQuickViewMetadataWithRole?.();
    getDealsFiltersAction();
    getDocumentTypesAction();
  }, []);
}
